import { DeleteOutlined, LoadingOutlined, MinusCircleOutlined, PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { tab } from "@testing-library/user-event/dist/tab";
import { Breadcrumb, Button, Card, Col, Flex, Layout, Radio, Row, Select, Space, Switch, Upload } from "antd";
import { Content, Footer } from "antd/es/layout/layout";
import { getBase64 } from "components/elements/upload/Upload.utils";
import { FormDatePicker, FormInput, FormInputNumber, FormRadio, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import MainLayout from "components/layouts/MainLayout";
import { compressedImage } from "features/employee/services/employeeApi";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles/ProductManagement.module.css";
import FormItem from "antd/es/form/FormItem";
import { useForm } from "antd/es/form/Form";
import { dataURLtoFile } from "utils/helper";
import dayjs from "dayjs";


const ProductManagementEdit = ({
    headPart = "",
    firstRow = () => { },
    table = () => { },
    onSubmit = () => { },
    onCancel = () => { },
    state = {}

}) => {
    const { t, i18n } = useTranslation();
    const [imageUrl, setImageUrl] = useState();
    const [loading, setLoading] = useState(false);
    const [form] = useForm()
    const { type, data } = state?.state
    console.log("state", state, type, data);

    useEffect(() => {
        if (data) {
            // data.activeDate = data.activeDate ? dayjs(data.activeDate) : null
            // data.expireDate = data.expireDate ? dayjs(data.expireDate) : null
            let status = data.activeStatus

            form.setFieldsValue({
                ...data
                , activeStatus: status == 'Y' ? true : false
                , whiteList: data.whiteList == 'Y' ? true : false
                , activeDate: data.activeDate ? dayjs(data.activeDate) : null
                , expireDate: data.expireDate ? dayjs(data.expireDate) : null
            })

            if (data.image) {
                getBase64(data.image, (url) => {
                    setImageUrl(url);
                    form.setFieldValue('image', dataURLtoFile(url))
                })
            }
        }

    }, [data])

    console.log(form.getFieldsValue(true));



    const onAvatarChange = async (info) => {
        setLoading(true);
        const compressImg = await compressedImage({
            file: info.file
        })
        getBase64(compressImg.data, (url) => {
            console.log("url2 ", url);
            setLoading(false);
            // setFieldValue("companyLogo", dataURLtoFile(url));
            setImageUrl(url);
            // form.setFieldValue("image", url)
            form.setFieldValue("image", dataURLtoFile(url));
        });
    };

    const onClearAvatar = (e) => {
        e.stopPropagation();
        // setFieldValue("companyLogo", null);
        setLoading(false);
        setImageUrl(null);
    };

    const productTypeOption = [
        {
            label: 'Payday',
            value: 'payday'
        },
        {
            label: i18n.language === "en" ? 'Installment Loan' : "สินเชื่อผ่อนชำระ",
            value: 'installmentLoan'
        }
    ]
    const feeTypeOption = [
        {
            label: i18n.language === "en" ? "Debt Collection Fee" : "ค่าติดตามทวงถามหนี้",
            value: 'FEE_01'
        },
        {
            label: i18n.language === "en" ? "Credit Limit Usage Fee" : 'ค่าธรรมเนียมการใช้วงเงิน',
            value: 'FEE_02'
        }
    ]

    function installmentPeriodOption(params) {
        if (params == "payday") {
            return [{ label: '1 งวด', value: 1 }]
        } else if (params == "installmentLoan") {
            return [{ label: '1 งวด', value: 3 }, { label: '6 งวด', value: 6 }, { label: '9 งวด', value: 9 }, { label: '12 งวด', value: 12 }]
        }
        else {
            return []
        }

    }

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: "none",
            }}
            type="button"
        >
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                {t("common.upload")}
            </div>
        </button>
    );

    return (
        <Layout>
            <Content>
                <Card style={{ border: "1px solid #EAECF0" }}>
                    <FormAntd form={form} initialValues={{
                        // feeTypeList: [1, 2, 3]
                    }}
                        onFinish={onSubmit}
                    >
                        <FormItem shouldUpdate={(prev, curv) => {

                            return prev['feeTypeList'] != curv['feeTypeList'] ||
                                prev['productType'] != curv['productType']
                        }} >
                            {({ getFieldsValue, getFieldValue, setFieldValue }) => {
                                return (
                                    <Space direction="vertical" size={24} style={{ width: "100%" }}>
                                        <Row gutter={[50, 10]}>
                                            <Col span={24}><h3>{t("product.header")}</h3></Col>
                                            <Col span={24}>
                                                <Flex justify="space-between"><span>{i18n.language === "en" ? "Basic configuration for the product" : "การกำหนดค่าที่เป็นพื้นฐานสำหรับผลิตภัณฑ์"}</span>
                                                    <FormSwitch disabled={type == 'view'} vertical={false} label={t("product.active_status")} name="activeStatus"></FormSwitch>
                                                </Flex>
                                            </Col>
                                            <Col span={24}>
                                                <Flex span={24} justify="center">
                                                    <Upload
                                                        disabled={type == 'view'}
                                                        name="companyLogo"
                                                        listType="picture-circle"
                                                        className={styles.avatarUploader}
                                                        showUploadList={false}
                                                        beforeUpload={() => false}
                                                        onChange={async (info) => onAvatarChange(info)}
                                                        action={null}
                                                    >
                                                        {imageUrl ? (
                                                            <>
                                                                <img
                                                                    src={imageUrl}
                                                                    alt="companyLogo"
                                                                    className={styles.avatar}
                                                                    style={{
                                                                        width: "100%",
                                                                    }} />
                                                                {
                                                                    type == 'view' ? "" :
                                                                        <MinusCircleOutlined
                                                                            className={styles.avatarMinusIcon}
                                                                            onClick={onClearAvatar} />
                                                                }

                                                            </>
                                                        ) : (
                                                            uploadButton
                                                        )}
                                                    </Upload>
                                                </Flex>
                                            </Col>
                                            {/* row 1 */}
                                            <Col span={8}><FormInput disabled={type == 'view'} size="large" name="productCode" required label={t("product.product_code")}></FormInput></Col>
                                            <Col span={8}><FormInput disabled={type == 'view'} size="large" name="name" required label={t("product.product_name")}></FormInput></Col>
                                            <Col span={8}><FormSelect disabled={type == 'view'} size="large" name="productType" options={productTypeOption} required label={t("product.product_type")} onChange={(e) => {
                                                if (e == 'payday') {
                                                    setFieldValue('installmentPeriod', [1])
                                                } else {

                                                    setFieldValue('installmentPeriod', null)
                                                }
                                            }}></FormSelect></Col>

                                            {/* row 2 */}
                                            <Col span={8}><FormInputNumber disabled={type == 'view'} size="large" name="minCredit" controls={false} required label={t("product.minimum_credit")}></FormInputNumber></Col>
                                            <Col span={8}><FormInputNumber disabled={type == 'view'} size="large" name="maxCredit" controls={false} required label={t("product.maximum_credit")}></FormInputNumber></Col>
                                            <Col span={8}><FormSelect disabled={type == 'view'} required mode="multiple" size="large" options={installmentPeriodOption(getFieldValue('productType'))} name="installmentPeriod" label={t("product.repayment")}></FormSelect></Col>
                                            {/* row 3 */}
                                            <Col span={8}><FormDatePicker disabled={type == 'view'} size="large" name="activeDate" required label={t("product.start_date")}></FormDatePicker></Col>
                                            <Col span={8}><FormDatePicker disabled={type == 'view'} size="large" name="expireDate" label={t("product.end_date")}></FormDatePicker></Col>
                                            <Col span={8}><FormSwitch disabled={type == 'view'} label={'white list'} name="whiteList"></FormSwitch></Col>
                                            {/* row 4 */}
                                            <Col span={24}><FormInput disabled={type == 'view'} placeholder={"http://"} name="url" size="large" required label="URL"></FormInput></Col>
                                            {/* row 5 */}
                                            <Col span={24}><FormInput disabled={type == 'view'} rows={3} type="textArea" name="description" size="large" required label={t("product.description")}></FormInput></Col>

                                        </Row>
                                        <Flex>
                                            <Row gutter={[50, 10]}>
                                                <Col span={24}><h3>{t("product.product_terms")}</h3></Col>
                                                <Col span={24}>
                                                    <Flex justify="space-between">
                                                        <span>{i18n.language === "en" ? "Rules and regulations governing product usage" : "ข้อกำหนดและข้อบังคับต่างๆ ที่กำหนดขึ้นเกี่ยวกับการใช้งานผลิตภัณฑ์"}</span>
                                                    </Flex>
                                                </Col>
                                                <Col span={24}></Col>
                                                <Col span={24}></Col>
                                                <Col span={8}><FormInputNumber disabled={type == 'view'} controls={false} size="large" name="interestRate" label={t("product.interest_year")}></FormInputNumber></Col>
                                                <Col span={16}></Col>
                                                {getFieldValue('feeTypeList')?.length > 0 ?
                                                    <>
                                                        <Col span={8}><span>{t("product.fee_type")}</span></Col>
                                                        <Col span={8}><span>{t("product.fee_unit")}</span></Col>
                                                        <Col span={8}><span>{t("product.fee")}</span></Col>
                                                    </>
                                                    :
                                                    <Col span={24}><span>{t("product.fee_type")}</span></Col>
                                                }
                                                {getFieldValue('feeTypeList')?.map?.((o, index) => {
                                                    setFieldValue("amountFee" + index, o.feeAmount)
                                                    setFieldValue("feeType" + index, o.feeType)
                                                    return <>
                                                        <Col span={8}><FormSelect disabled={type == 'view'} size="large" name={"feeType" + index} options={feeTypeOption} required onChange={(e) => {
                                                            let list = getFieldValue("feeTypeList") ? [...getFieldValue("feeTypeList")] : []
                                                            setFieldValue("feeTypeList", list.map((o, idx) => {
                                                                if (idx == index) {
                                                                    return {
                                                                        ...o,
                                                                        feeType: e
                                                                    }
                                                                } else {
                                                                    return o
                                                                }
                                                            }));
                                                        }}></FormSelect></Col>
                                                        <Col span={8}>
                                                            <Flex>
                                                                <Radio.Group disabled={type == 'view'}
                                                                    onChange={(e) => {
                                                                        let list = getFieldValue("feeTypeList") ? [...getFieldValue("feeTypeList")] : []
                                                                        setFieldValue("feeTypeList", list.map((o, idx) => {
                                                                            if (idx == index) {
                                                                                return {
                                                                                    ...o,
                                                                                    feeUnit: e.target.value
                                                                                }
                                                                            } else {
                                                                                return o
                                                                            }

                                                                        }));
                                                                    }}
                                                                    defaultValue={"BATH"}
                                                                    value={o?.feeUnit}
                                                                >
                                                                    <Radio value={"BATH"}>
                                                                        {t("unit.baht")}
                                                                    </Radio>
                                                                    <Radio value={"PERCEN"}>
                                                                        {t("unit.percentage")}
                                                                    </Radio>
                                                                </Radio.Group></Flex>

                                                        </Col>
                                                        <Col span={6}><FormInputNumber disabled={type == 'view'} onChange={(e) => {
                                                            let list = getFieldValue("feeTypeList") ? [...getFieldValue("feeTypeList")] : []
                                                            setFieldValue("feeTypeList", list.map((o, idx) => {
                                                                if (idx == index) {
                                                                    return {
                                                                        ...o,
                                                                        feeAmount: e
                                                                    }
                                                                } else {
                                                                    return o
                                                                }
                                                            }));
                                                        }} controls={false} required name={"amountFee" + index} size="large"></FormInputNumber>   </Col>
                                                        <Col span={2}>
                                                            {type == 'view' ? "" :
                                                                <DeleteOutlined onClick={() => {
                                                                    console.log("index", index);
                                                                    let list = getFieldValue("feeTypeList") ? [...getFieldValue("feeTypeList")] : []
                                                                    setFieldValue("feeTypeList", list.filter((o, idx) => idx != index))
                                                                }} />}  </Col>
                                                    </>
                                                })}
                                                {type == 'view' ? "" :
                                                    <Button
                                                        className={styles.buttonAdd}
                                                        onClick={() => {
                                                            let list = getFieldValue("feeTypeList") ? [...getFieldValue("feeTypeList")] : []
                                                            list.push({ feeUnit: 'BATH' })
                                                            setFieldValue("feeTypeList", list)
                                                        }}
                                                    >
                                                        <PlusCircleOutlined />
                                                        <span>{t('leave_type.label.add')}</span>
                                                    </Button>
                                                }
                                            </Row>

                                        </Flex>


                                    </Space>)
                            }}
                        </FormItem>
                    </FormAntd>
                </Card>
            </Content>
            <Footer style={{
                // display: type == 'edit' ? "flex" : "none",
                zIndex: 999,
                bottom: 1,
                position: 'sticky',
                backgroundColor: 'white',
                // height: "5vh",
                padding: '10px 50px',
                justifyContent: 'end',
                alignItems: 'center',
            }}>
                <Row justify="end" style={{ gap: "12px" }}>
                    <Button type="default" onClick={() => {
                        onCancel();
                        form.resetFields()
                    }}
                        style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                    >
                        {t("common.cancel").toUpperCase()}
                    </Button>
                    {(type == 'edit' || type == 'create') &&
                        <Button type="primary" onClick={() => {
                            // HandleSave()
                            form.submit()
                        }}
                            style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white" }}
                        >
                            {t("common.submit").toUpperCase()}
                        </Button>
                    }
                </Row>
            </Footer>
        </Layout>
    )
}

export default ProductManagementEdit;
